import {serializeFilters} from 'nutshell-core';
import type {ReportGap, FilterObject} from 'nutshell-core/types';

export type ChartParams = {
    gap: ReportGap;
};

export type ReportPostParams = {
    filter: any;
    gap: ReportGap;
};

export function getReportPostParams(
    reportParams: ChartParams,
    filters: FilterObject[]
): ReportPostParams {
    const {gap} = reportParams;

    return {
        filter: serializeFilters(filters),
        gap,
    };
}
